import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetUserApplicationDetailsRequestObjectType,
  GetUserApplicationDetailsResponseType
} from '../../../services/NwApplicationServices/APIService/types';
import { networkCallWithApisauceWithHeaders } from '../../../utils/AuthAPIUtils';

import { useAccountsRefreshAuthTokens } from '../../useAccountsRefreshAuthTokens';

import { useNwApplicationService } from '../useNwApplicationService';

interface UseGetApplicationDetailsInterface {
  getApplicationDetailsApi: UseMutateAsyncFunction<
    GetUserApplicationDetailsResponseType,
    Error,
    {
      applicationNameEnum: string;
      requestObject: GetUserApplicationDetailsRequestObjectType;
      access_token?: string;
    }
  >;
  error: string | null;
  status: MutationStatus;
}

const useGetApplicationDetailsApi = (): UseGetApplicationDetailsInterface => {
  const { nwApplicationService } = useNwApplicationService();
  const { refreshTokenApi, getRefreshToken } = useAccountsRefreshAuthTokens();
  const getApplicationDetails = ({
    applicationNameEnum,
    requestObject,
    access_token
  }: {
    applicationNameEnum: string;
    requestObject: GetUserApplicationDetailsRequestObjectType;
    access_token?: string;
  }) => {
    if (access_token) {
      return nwApplicationService.getUserApplicationDetails(
        applicationNameEnum,
        requestObject,
        networkCallWithApisauceWithHeaders({
          refreshAuthTokensAPI: refreshTokenApi,
          getAccessToken: () => access_token,
          getRefreshToken
        })
      );
    } else
      return nwApplicationService.getUserApplicationDetails(
        applicationNameEnum,
        requestObject
      );
  };

  const { mutateAsync, error, status } = useMutation(getApplicationDetails, {
    mutationKey: ['getApplicationDetailsApi']
  });

  return {
    getApplicationDetailsApi: mutateAsync,
    error: error ? getAPIErrorMessage(error) : null,
    status
  };
};

export { useGetApplicationDetailsApi };
